/**

 * Navigation component for workspace header

 *

 * Renders the back navigation button based on the current page.

 */



import { Button } from '@/ui';

import { useNavigate } from 'react-router-dom';

import {

  CompactNavButton,

  LeftSection,

} from '../../WorkspaceHeaderLayout.styles';

import { WORKSPACE_NAVIGATION_CONFIG } from '../workspaceHeaderNavigationConfig';



export type WorkspaceActivePage =

  | 'workspace'

  | 'ask-hub'

  | 'ask-session'

  | 'documents'

  | 'activities'

  | 'prompt-library';



interface WorkspaceHeaderNavigationProps {

  activePage: WorkspaceActivePage;

  workspaceId: string;

  isCompactTheme?: boolean;

}



export const WorkspaceHeaderNavigation: React.FC<WorkspaceHeaderNavigationProps> = ({

  activePage,

  workspaceId,

  isCompactTheme = false,

}) => {

  const navigate = useNavigate();

  const config = WORKSPACE_NAVIGATION_CONFIG[activePage];



  if (!config) {

    return null;

  }



  const path = config.path.replace('{id}', workspaceId);

  const label = isCompactTheme ? config.compactLabel : config.label;



  const handleNavigate = () => {

    navigate(path);

  };



  return (

    <LeftSection $isCompact={isCompactTheme}>

      {isCompactTheme ? (

        <CompactNavButton type="button" onClick={handleNavigate}>

          {label}

        </CompactNavButton>

      ) : (

        <Button variant="secondary" onClick={handleNavigate}>

          {label}

        </Button>

      )}

    </LeftSection>

  );

};

